import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

import { Dashboard } from './pages/index';
import { useGlobalContext } from './provider';
import { Loading } from './components/Loading';
import { LogIn } from './pages/auth/login';
import { Register } from './pages/auth/register';
import { NewCourse } from './pages/newCourse';
import { BrowseCourse } from './pages/browseCourse';
import { CourseDetails } from './pages/courseDetails';
import { Profile } from './pages/profile';
import {Pdf} from './pages/PDF';
import {PDFDetail} from './pages/PDF/pdfDetail';
import { About } from './pages/about';
import { Extra } from './pages/extra';
import { Contact } from './pages/contact';
import { Settings } from './pages/settings/settings';
import { Product } from "./pages/product";
import { ProductDetails } from "./pages/product/product-details";
import { Terms } from "./pages/terms";
import { Privacy } from "./pages/privacy";

export const Routers = () => {
  const [globalState]: GlobalContextType = useGlobalContext();

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Dashboard />} />

        {!globalState.loginStatus && (
          <React.Fragment>
            <Route path='/login' element={<LogIn />} />
            <Route path='/register' element={<Register />} />
          </React.Fragment>
        )}

        {globalState.loginStatus && (
          <React.Fragment>
            <Route path='/profile' element={<Profile />} />
            <Route path='/newCourse' element={<NewCourse />} />
            <Route path='/settings/*' element={<Settings />} />
          </React.Fragment>
        )}

        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />

        <Route path='/browseCourse' element={<BrowseCourse />} />
        <Route path='/browseCourse/:id' element={<BrowseCourse />} />
        <Route path='/course/:id' element={<CourseDetails />} />
        <Route path="/pdf"  element={<Pdf />} />
        <Route path="/pdf/:id"  element={<PDFDetail />} />
        <Route path="/extra" element={<Extra />} />
        <Route path='/product' element={<Product />} />
        <Route path='/product/:id' element={<ProductDetails />} />

        <Route path='/terms' element={<Terms />} />
        <Route path='/privacy' element={<Privacy />} />

        <Route path='*' element={<Dashboard />} />
      </Routes>

      <NotificationContainer />
      <Loading state={globalState.loading} opacity={0.75} />
    </BrowserRouter>
  )
}